import './global.scss'

import { QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { queryClient } from '#/core/react-query'
import { MossProvider } from '#/hooks'

import { AxieJam } from './src/app/app'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MossProvider>
        <AxieJam />
      </MossProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
